import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';


const instance = axios.create({
    baseURL:location.origin.indexOf('localhost') > -1 ? 'http://localhost:53826/api/' :
    location.origin.indexOf('desenv') > -1 ?
    'https://homologa.comprasnetadm.ba.gov.br/api/'
    : location.origin.indexOf('homologa2') > -1 ?
    'https://homologa2.comprasnetadm.ba.gov.br/api/'
    : location.origin.indexOf('homologa') > -1 ?
    'https://homologa.comprasnetadm.ba.gov.br/api/'    
    : location.origin.indexOf('treinamento') > -1 ?
    'http://treinamento.comprasnetadm.ba.gov.br/api/'
    :
    'https://www.comprasnetadm.ba.gov.br/api/'

});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
     Vue.toasted.error(error.response.data.message);
     return Promise.reject(error.response);
});


Vue.use(Vuex);

export default {
    logar(model) {
        
        // Responsavel em obter o ID do tipo de Documento no SEI
        let id_tipo_documento_sei = 138;
        /*
        if( location.origin.indexOf('localhost') > -1){
            id_tipo_documento_sei = 138;
        }else if( location.origin.indexOf('desenv') > -1 ){

            id_tipo_documento_sei = 138;
        }else if( location.origin.indexOf('homologa') > -1 ){

            id_tipo_documento_sei = 138;

        }else{
            id_tipo_documento_sei = 138;
        }
        */
        window.localStorage.setItem("id_tipo_documento_sei", id_tipo_documento_sei );
                              
        return instance.post('login', model);
    },
    loginRestrito(model) {
        
        // Responsavel em obter o ID do tipo de Documento no SEI
        let id_tipo_documento_sei = 138;
        /*
        if( location.origin.indexOf('localhost') > -1){
            id_tipo_documento_sei = 138;
        }else if( location.origin.indexOf('desenv') > -1 ){

            id_tipo_documento_sei = 138;
        }else if( location.origin.indexOf('homologa') > -1 ){

            id_tipo_documento_sei = 138;

        }else{
            id_tipo_documento_sei = 138;
        }
        */
        window.localStorage.setItem("id_tipo_documento_sei", id_tipo_documento_sei );

        return instance.post('usuario/autenticacao', model);
    },
    cadastrarUsuario(model) {
      model.cpf = model.cpf.replace(/[^\d]+/g, '');
      model.telefone = model.telefone.replace(/[^\d]+/g, '');
      return instance.post("usuario/incluirusuariocadastrador", model)
    },
    cadastroinicial(model) {
        return instance.post('fornecedor/cadastroinicial', model);
    },
    recuperarsenha(model){
        return instance.post('seguranca/recuperarsenha', model);
    },
    recuperarSenhaServidor(model){
        return instance.post('seguranca/recuperarSenhaServidor', model);
    },
    consultarEmailsAdicionais(model) {
        return instance.post('fornecedor/consultarEmailsAdicionais', model);
    },
    validarcodativacao(model){
        return instance.post('seguranca/validarcodativacao', model);
    },
    validarCodativacaoServidor(model){
        return instance.post('seguranca/validarCodativacaoServidor', model);
    },
    alterarEmail(model) {
        return instance.post('seguranca/alteraremail', model);
    },
    alterarEmailUsuario(model) {
        return instance.post('seguranca/alteraremailusuario', model);
    },
    obterSenhaAtualUsuario(model) {
        return instance.post('seguranca/ObterSenhaAtualUsuario', model);
      },
      enviaEmailRecuperacao(email){
        return instance.post('seguranca/enviaEmailRecuperacao', email);
    },
    alterarsenha(model){
        return instance.post('seguranca/alterarsenha', model);
    },
    alterarSenhaUsuario(model) {
        return instance.post('seguranca/alterarsenhausuario', model);
      },
    obterSenhaAtual(model) {
        return instance.post('seguranca/ObterSenhaAtual', model);
    },
    alterarSenhaServidor(model){
        return instance.post('seguranca/alterarSenhaServidor', model);
    },
    validarcadastroinicial(model){
        return instance.post('fornecedor/validarcadastroinicial', model);
    },
    getRedeGoverno() {
      return instance.get("dominio/redegoverno");
    },
    getSecretarias() {
      return instance.get("dominio/secretarias");
    },
    getUnidades(secretariaId) {
      return instance.get(`dominio/unidades?codSecretaria=${secretariaId}`);
    },
    getCombosDadosBasicos() {
      return instance.get("dominio/getCombosDadosBasicos");
    },
    getCidade(model) {
      return instance.post("dominio/municipio", model);
    },
    getAmbienteBd() {
        return instance.get("dominio/getambientebd");
    },
};
